import type { IconSvgObject } from './types';

const Csv01Icon: IconSvgObject = [
  ["path", { d: "M4 13V4.0022C4 2.89676 4.89679 2.00097 6.00223 2.0022L12.9958 2.00998L20 9V13M13 2.5V7C13 8.10457 13.8954 9 15 9H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 16H11C10.4477 16 10 16.4477 10 17V18C10 18.5523 10.4477 19 11 19H12C12.5523 19 13 19.4477 13 20V21C13 21.5523 12.5523 22 12 22H10M15.5 16L17.75 22L20 16M7.5 21C7.5 21.5523 7.05228 22 6.5 22H5C4.44772 22 4 21.5523 4 21V17C4 16.4477 4.44772 16 5 16H6.5C7.05228 16 7.5 16.4477 7.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Csv01Icon;
